
import React from 'react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface ModalFooterProps {
  campaign: any;
  canDismiss: boolean;
  dismissPermanently: boolean;
  onDismissPermanentlyChange: (checked: boolean) => void;
  onDismiss: () => void;
  isMobile: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  campaign,
  canDismiss,
  dismissPermanently,
  onDismissPermanentlyChange,
  onDismiss,
  isMobile,
}) => {
  const showPermanentDismissOption = campaign.allow_dismiss && canDismiss;
  
  return (
    <div className="w-full">
      {showPermanentDismissOption && (
        <div className="flex items-center space-x-2 mb-4">
          <Checkbox
            id="dismissPermanently"
            checked={dismissPermanently}
            onCheckedChange={(checked) => onDismissPermanentlyChange(!!checked)}
          />
          <Label htmlFor="dismissPermanently" className="cursor-pointer">Niet meer tonen</Label>
        </div>
      )}
      
      <Button
        variant={canDismiss ? "default" : "secondary"}
        onClick={onDismiss}
        disabled={!canDismiss}
        className={`w-full ${canDismiss ? "" : "opacity-50 cursor-not-allowed"}`}
      >
        {canDismiss 
          ? "Sluiten" 
          : campaign.has_quiz 
            ? "Quiz volledig voltooien om te sluiten" 
            : "Deze content kan niet worden gesloten"
        }
      </Button>
    </div>
  );
};

export default ModalFooter;
